<script lang="ts">
	import { onMount } from 'svelte';
	// import './static/partners.css';
	export let header = false;
	export let footer = false;

	let partners_header: HTMLDivElement;
	let partners_footer: HTMLDivElement;

	onMount(async () => {
		// const data = await getPartnerData();
		// // Set innerHTML after element references are defined
		// if (header && partners_header) {
		// 	partners_header.innerHTML = data.header ?? '';
		// }
		// if (footer && partners_footer) {
		// 	partners_footer.innerHTML = data.footer ?? '';
		// }
	});
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<!-- <iframe
	bind:this={partners_iframe}
	id="branding-iframe"
	src="https://partners.kingtechnology.com"
/> -->
{#if header}
	<div class="header-wrapper-full" id="header">
		<div class="container-fluid header-wrapper" id="header-container">
			<div class="row header-top">
				<div class="col-xs-6 header-logo">
					<a href="https://partners.kingtechnology.com/">
						<img
							src="https://partners.kingtechnology.com/wp-content/uploads/2020/02/king-header-logo.jpg"
							alt=""
							width="180"
							height="102"
							class="alignnone size-full wp-image-9"
						/>
					</a>
				</div>
			</div>
		</div>
	</div>
{/if}
{#if footer}
	<div class="footer-wrapper-full container-fluid">
		<div class="footer-wrapper container" id="footer">
			<div class="row footer-columns">
				<div class="col-sm-3 footer-one">
					<ul class="footer-one-list">
						<li>© 2024 King Technology, Inc. All rights reserved.</li>
						<li>6000 Clearwater Drive</li>
						<li>Minnetonka, MN 55343</li>
						<li>952-933-6118</li>
					</ul>
				</div>
				<div class="col-sm-3 footer-two">
					<ul class="footer-two-list">
						<li>
							<a href="https://partners.kingtechnology.com/documents-and-downloads/">Documents</a>
						</li>
						<li><a href="http://training.kingtechnology.com/">Training</a></li>
						<li><a href="https://partners.kingtechnology.com/programs/">Programs</a></li>
						<li><a href="https://partners.kingtechnology.com/policies/">Policies</a></li>
						<li>
							<a href="https://partners.kingtechnology.com/programs/dealer-locator-sign-up/"
								>Dealer Locator Sign Up</a
							>
						</li>
					</ul>
				</div>
				<div class="col-sm-3 footer-three">
					<ul>
						<li><a href="https://partners.kingtechnology.com/">Home</a></li>
						<li><a href="https://partners.kingtechnology.com/about-us/">About Us</a></li>
						<li><a href="https://partners.kingtechnology.com/contact-us/">Contact</a></li>
					</ul>
				</div>
				<div class="col-sm-3 footer-contact">
					<h5>Contact Customer Service</h5>
					<ul>
						<li>
							<span class="footer-icon phone-icon">
								<img
									loading="lazy"
									decoding="async"
									src="https://partners.kingtechnology.com/wp-content/uploads/2020/02/phone-icon.png"
									alt=""
									width="16"
									height="19"
									class="alignnone size-full wp-image-12"
								/>
							</span>
							<a href="tel:18002220169">1-800-222-0169</a>
						</li>
						<li>
							<span class="footer-icon email-icon">
								<img
									loading="lazy"
									decoding="async"
									src="https://partners.kingtechnology.com/wp-content/uploads/2020/02/email-icon.png"
									alt=""
									width="21"
									height="15"
									class="alignnone size-full wp-image-11"
								/>
							</span>
							<a href="mailto:customer.service@kingtechnology.com"
								>customer.service@kingtechnology.com</a
							>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<footer id="copyright">
			<div class="container fixed-width-column">
				<div class="row padding-full footer-bottom">
					<div class="col-sm-12 copyright" />
				</div>
			</div>
		</footer>
	</div>
{/if}

<style>
	/* Shared */
	.container {
		padding: 0;
	}
	.row {
		margin-left: 0;
		margin-right: 0;
	}
	.col-sm-3 {
		padding-right: 0;
		padding-left: 0;
	}

	h5 {
		margin-bottom: 15px;
		color: #ed6a2b;
		font-size: 25px;
		line-height: 30px;
		font-weight: 700;
		text-transform: uppercase;
		margin-top: 85px;
	}
	a {
		outline: none !important;
		transition: all 0.2s ease-in-out;
		-moz-transition: all 0.2s ease-in-out;
		-webkit-transition: all 0.2s ease-in-out;
		-o-transition: all 0.2s ease-in-out;
	}
	a:link {
		text-decoration: none;
		color: #00a7e0;
		outline: none;
	}

	a:visited {
		text-decoration: none;
		color: #00a7e0;
		outline: none;
	}

	a:hover {
		text-decoration: none;
		color: #c1d52f;
		outline: none;
	}

	/* Header */
	html :where(img[class*='wp-image-']) {
		height: auto;
		max-width: 100%;
	}
	#header-container .padding-full {
		padding-left: 0;
		padding-right: 0;
	}
	#header {
		height: auto;
		width: 100%;
		z-index: 1;
		margin-bottom: 0;
		border: none;
		clear: both;
		background: transparent
			url(//partners.kingtechnology.com/wp-content/themes/KingPartner/images/header-bg.png) repeat-x;
		position: relative;
	}

	#header img.fullsize-logo {
		display: block;
		margin: 0;
	}

	.header-top {
		max-width: 1200px;
		margin-left: auto;
		margin-right: auto;
		position: relative;
		height: 102px;
		line-height: 27px;
		font-size: 14px;
		z-index: 8;
		padding: 0 30px;
		text-decoration: none;
	}

	img {
		vertical-align: middle;
	}

	/* Footer */
	.footer-wrapper-full {
		background: transparent
			url(//partners.kingtechnology.com/wp-content/themes/KingPartner/images/footer-bg.png) repeat-x;
		height: 150px;
		position: relative;
		z-index: 200;
	}

	.footer-columns {
		padding: 26px 20px;
	}

	#footer {
		background-color: transparent !important;
		padding-top: 0 !important;
	}

	#footer,
	#footer li,
	#footer h5,
	#footer a {
		color: #fff;
	}

	#footer ul {
		margin-left: 0;
		padding-left: 0;
	}

	#footer li {
		font-size: 12px;
		line-height: 18px;
		padding-bottom: 1px;
		font-weight: 700;
		list-style-type: none;
	}

	#footer li a {
		text-decoration: underline;
	}

	#footer h5 {
		font-size: 14px;
		line-height: 18px;
		text-transform: none;
		font-weight: 800;
		margin-top: 0;
		margin-bottom: 10px;
	}

	.footer-one ul li {
		padding-bottom: 1px;
	}

	.footer-contact ul > li {
		white-space: nowrap;
	}

	.footer-contact ul li:first-child {
		margin-bottom: 10px;
	}

	.footer-contact span.footer-icon {
		width: 21px;
		display: inline-block;
		margin-right: 5px;
	}

	footer#copyright {
		background-color: transparent !important;
	}

	.fixed-width-column,
	.container.fixed-width-column {
		max-width: 1200px !important;
		margin-left: auto !important;
		margin-right: auto !important;
		float: none !important;
	}

	@media (max-width: 767px) {
		li {
			font-size: 15px;
			line-height: 24px;
		}

		h5 {
			font-size: 20px;
			line-height: 24px;
			margin-top: 54px;
		}
		.footer-wrapper-full {
			background: transparent
				url(//partners.kingtechnology.com/wp-content/themes/KingPartner/images/footer-bg-mobile.png)
				repeat-x;
			height: auto;
		}
		.footer-columns {
			text-align: center;
		}
		.col-sm-3 {
			float: left;
		}
	}
	@media (min-width: 768px) and (max-width: 991px) {
		h5 {
			margin-bottom: 15px;
			font-size: 16px;
			line-height: 19px;
			margin-top: 85px;
		}
		li {
			font-size: 13px;
			line-height: 20px;
		}
		.footer-wrapper-full {
			font-size: 11px;
			line-height: 16px;
			padding: 20px 0;
		}
		#footer .footer-two.col-sm-3,
		#footer .footer-three.col-sm-3 {
			width: 20%;
		}

		.footer-columns {
			padding: 5px 20px;
		}
	}
	@media (min-width: 992px) and (max-width: 1199px) {
		li {
			font-size: 17px;
			line-height: 26px;
		}
		h5 {
			margin-bottom: 15px;
			font-size: 21px;
			line-height: 25px;
			margin-top: 85px;
		}
		.footer-wrapper-full {
			font-size: 12px;
			line-height: 21px;
			padding: 20px 0;
		}
		.footer-columns {
			padding: 10px 20px;
		}

		#footer .footer-two.col-sm-3,
		#footer .footer-three.col-sm-3 {
			width: 23%;
		}
	}
</style>
